import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { FacilityReportsList } from "../../components/FacilityReportsComponents/FacilityReportsList";
import { useFacilityReports } from "../../components/FacilityReportsComponents/FacilityReportsList/hooks";
import { ModalCreateNewFacilityReport } from "../../components/FacilityReportsComponents/FacilityReportsList/ModalCreateNew";

import "./styles.scss";

const FacilityReportsPage: React.FC = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityReportsPage.${key}`);

  const [isModalCreateNewOpen, setIsModalCreateNewOpen] = useState(false);

  const { create } = useFacilityReports();

  const handleCreateReport = async (payload: any) => {
    try {
      await create(payload);
      handleCloseModalCreateNew();
    } catch {
      // Do nothing. Axios should handle displaying the error automatically.
    }
  };

  const handleOpenModalCreateNew = () => {
    setIsModalCreateNewOpen(true);
  };

  const handleCloseModalCreateNew = () => {
    setIsModalCreateNewOpen(false);
  };

  return (
    <>
      <div className="right-content facility-reports-page">
        <div className="top-title-bar">
          <PageTitle text={t("facility_reports")} />
          <button className="btn btn-blue" onClick={handleOpenModalCreateNew}>
            {t("create_report")}
          </button>
        </div>
        <div className="line"></div>
        <FacilityReportsList />
      </div>
      {isModalCreateNewOpen && (
        <ModalCreateNewFacilityReport
          handleClose={handleCloseModalCreateNew}
          handleSubmit={handleCreateReport}
        />
      )}
    </>
  );
};

export default withRouter(FacilityReportsPage);
